export default function () {
    const imageComponents = document.querySelectorAll('.c-media');
    const tableComponents = document.querySelectorAll('table');

    for (var i = 0, len = imageComponents.length; i < len; i++) {
        imageComponents[i].parentNode.classList.add('col-image');
        imageComponents[i].parentNode.parentNode.classList.add('row-image');
    }
    for (var i3 = 0, len3 = tableComponents.length; i3 < len3; i3++) {
        tableComponents[i3].parentNode.parentNode.classList.add('c-table');

        // element that will be wrapped
        var el = tableComponents[i3];
        el.className = 'table table-striped';

        // create wrapper container
        var wrapper = document.createElement('div');
        wrapper.className = 'table-responsive';

        // insert wrapper before el in the DOM tree
        el.parentNode.insertBefore(wrapper, el);

        // move el into wrapper
        wrapper.appendChild(el);
    }
};
